import { render, staticRenderFns } from "./WorkspaceNavCard.vue?vue&type=template&id=ba83fe30&scoped=true&"
import script from "./WorkspaceNavCard.vue?vue&type=script&lang=js&"
export * from "./WorkspaceNavCard.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceNavCard.vue?vue&type=style&index=0&id=ba83fe30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba83fe30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba83fe30')) {
      api.createRecord('ba83fe30', component.options)
    } else {
      api.reload('ba83fe30', component.options)
    }
    module.hot.accept("./WorkspaceNavCard.vue?vue&type=template&id=ba83fe30&scoped=true&", function () {
      api.rerender('ba83fe30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workspace/WorkspaceNavCard.vue"
export default component.exports